export enum FillinOrigin {
  app = 'app',
  externalApi = 'external_api',
  autoSystem = 'auto_system',
  manuallyAdded = 'manually_added',
  pumpX = 'pump_x',
  inCharge = 'incharge'
};

export namespace FillinOrigin {
  export const translateOrigin = (origin: FillinOrigin): string => {
    switch (origin) {
      case FillinOrigin.app:
        return "Aplicativo"
      case FillinOrigin.externalApi:
        return "Parceiros Externos";
      case FillinOrigin.autoSystem:
        return "Auto System";
      case FillinOrigin.manuallyAdded:
        return "Adicionado Manualmente";
      case FillinOrigin.pumpX:
        return "PumpX";
      case FillinOrigin.inCharge:
        // Recarga de veículo elétrico (integração InCharge). Sem este case o `default`
        // devolveria "" e a origem sairia em branco na listagem e no filtro de fillins —
        // `fillinOriginChoices` é gerado do enum, mas o rótulo vem daqui.
        return "Recarga Elétrica";
      default: return "";
    };
  };

  export const fillinOriginChoices = Object.values(FillinOrigin).filter(x => typeof x === "string")
    .map(type => {
      return ({
        id: type,
        name: FillinOrigin.translateOrigin(type)
      })
    });
};
